export default "__VITE_ASSET__C0$Lx1P8__"